import {PlayerBase} from "../../player/player.base";
import {Component, Injector} from '@angular/core';
import {Observable, of, switchMap, takeUntil} from "rxjs";
import {catchError, tap} from "rxjs/operators";

@Component({
  selector: 'app-keyboard',
  template: '<div #component></div>',
  styleUrls: []
})
export class KeyboardComponent extends PlayerBase {
  constructor(protected  injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        return of('a');
      }),
      catchError(err => this.logError(err)),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

}
